import { get, post } from '../utils/api';
import { ENDPOINTS } from '../utils/constants';
import store from '../store';

export const offersService = {
  // Debug: Check if token exists
  checkToken: () => {
    const token = store.getState().auth.accessToken?.access_token;
    console.log('Current token:', token ? 'Token exists' : 'No token found');
    return !!token;
  },

  // Teklif ücreti bilgisini getir
  getOfferPrice: async () => {
    try {
      console.log('💰 Fetching offer price...');
      const response = await get(ENDPOINTS.OFFER_PRICE + "/");
      console.log('✅ Offer price response:', response);
      return response;
    } catch (error) {
      console.error('❌ Error fetching offer price:', error);
      throw error;
    }
  },

  // Açık talepleri getir
  getAvailableRequests: async (params = {}) => {
    try {
      console.log('🔍 Fetching available requests...', params);
      const response = await get(ENDPOINTS.AVAILABLE_REQUESTS + "/", params);
      console.log('✅ Available requests response:', response);
      return response;
    } catch (error) {
      console.error('❌ Error fetching available requests:', error);
      throw error;
    }
  },

  // Teklif ver
  createOffer: async (offerData) => {
    try {
      console.log('💬 Creating offer...', offerData);
      const response = await post(ENDPOINTS.OFFERS + "/", offerData);
      console.log('✅ Offer creation response:', response);
      return response;
    } catch (error) {
      console.error('❌ Error creating offer:', error);
      throw error;
    }
  },

  // Kendi tekliflerini getir
  getMyOffers: async (params = {}) => {
    try {
      console.log('📋 Fetching my offers...', params);
      const response = await get(ENDPOINTS.OFFERS + "/", params);
      console.log('✅ My offers response:', response);
      return response;
    } catch (error) {
      console.error('❌ Error fetching my offers:', error);
      throw error;
    }
  }
};

export default offersService; 